import './index.scss';

window.addEventListener('load', function(){
  if(typeof(gsap) === 'undefined') return;
  gsap.utils.toArray(".pd-block-sequence-section").forEach((section, i) => {
    const image = section.querySelector('.sequence-bg')
    gsap.timeline({ 
      scrollTrigger: {
        trigger: section,
        scrub: true,
        invalidateOnRefresh: true
      }})
      .fromTo(image, { 
      x: "80px"        
    }, {
      x: 0,
      ease: "none"
    });
  });
})